<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'Route',
  render: (h) => h(),
  data: () => ({
    localisation: 'room'
  }),
  beforeDestroy() {
    this.$scene.unregisterBeforeRender(this.onRender)
  },
  beforeCreate() {
    this.$scene = this.$parent.$scene
    this.$camera = this.$parent.$camera

    // this.$animGear = _.find(this.$scene.animationGroups, a => a.name == 'gears')
    this.$animGear = _.find(this.$scene.animationGroups, a => a.name == 'SM_MR_Books_low_animatedAction')
    // this.$animBibli = _.find(this.$scene.animationGroups, a => a.name == 'bibli')
    this.$animBibli = _.find(this.$scene.animationGroups, a => a.name == 'MR_bibli_animatedAction')
    // this.$animPorte = _.find(this.$scene.animationGroups, a => a.name == 'door')
    this.$animPorte = _.find(this.$scene.animationGroups, a => a.name == 'door_SR_door')

    this.$animBibli['isActive'] = false
    this.$animPorte['isActive'] = false

    this.$pos = { room: 50, corridor: -250, stairs: -520, secret: -600 }
  },
  created() {
    this.$scene.registerBeforeRender(this.onRender)
    this.unFreeze(this.$animGear, false)
    this.$animGear.play(true)
  },
  methods: {
    onRender() {
      _.each(this.$pos, (p,k) => {
        if(this.$scene.activeCamera.position.z < p)
          this.localisation = k
      })
    },
    checkLocalisation() {
      const slug = this.$route.params.slug
      if(this.localisation == 'secret' && slug == 'tunnel:1')
        this.next()
      if(this.localisation == 'room' && slug == 'tunnel:2')
        this.next()
    },
    unFreeze(meshAnim, freeze) {
      const target = meshAnim.targetedAnimations[0].target
      const group = [target, ...target.getChildMeshes()]
      _.each(group, mesh => mesh.unfreezeWorldMatrix())
      if(freeze)
        TweenMax.delayedCall(6, () => _.each(group, mesh => mesh.freezeWorldMatrix()))
    }
  },
  watch: {
    localisation: {
      immediate: true,
      handler() {
        if((['corridor', 'secret'].indexOf(this.localisation) > -1 || this.$route.meta.name == 'artwork') && !this.$animPorte.isActive) {
          this.unFreeze(this.$animPorte)
          this.$animPorte.play(false)
          this.$animPorte.isActive = true
        }
        this.checkLocalisation()
      }
    },
    '$route': {
      immediate: true,
      handler() {
        if((this.slugIsAfter('use-tunnel') || this.$route.meta.name == 'artwork') && !this.$animBibli.isActive) {
          TweenMax.delayedCall(1, () => {
            this.unFreeze(this.$animBibli)
            this.$animBibli.play(false)
            this.$animBibli.isActive = true
            TweenMax.delayedCall(5, () => {
              const target = this.$animBibli.targetedAnimations[0].target
              const group = [target, ...target.getChildMeshes()]
              _.each(group, mesh => mesh.dispose())
            })
          })
        }
        this.checkLocalisation()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Localisator.vue